import Confirmation from '../Confirmation';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { FrameworkActionCreator, ICustomerState, AppointmentActionCreator, IAppointmentState, CustomerActionCreator, VehiclesActionCreator, RepairOrdersActionCreator, ROHistoryActionCreator, MenusActionCreator, NewVehicleActionCreator } from 'src/store/states';
import { BlankDeptSpec } from 'src/models/Specs/TestSpecs';

const mapStateToProps = (state: IStoreState & ICustomerState & IAppointmentState) => ({
    custInfo: state.Customer.Customer,
    appointment: state.Appointment,
    vehicle: state.Appointment.ApptVeh,
    viewMode: state.Framework.viewMode,
    specData: state.Specs.specs,
    theme: state.Framework.theme,
    colorSensitiveEnabled: state.Framework.colorSensitiveEnabled,
    specDeptData: state.Specs.deptSpecs !== undefined ? state.Specs.deptSpecs : BlankDeptSpec,
    specProfile: state.Framework.specProfile,
    store: state.Framework.store,
    branch: state.Framework.branch,
    vehicleList: state.Vehicles.vehicles,
    locale: state.Framework.locale,
    selectedVehicle: state.Vehicles.selectedVehicle !== undefined ? state.Vehicles.selectedVehicle : '',
    loading: state.Customer.loading,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    addlTrackVin: state.Framework.addlTrackVin,
    vwDeepLinkMileage: state.Framework.vwDeepLinkMileage,
    vwProvider: state.Framework.vwProvider,
    vwKeyword: state.Framework.vwKeyword,
    vwVariant: state.Framework.vwVariant,
});

const mapDispatchToProps = {
    updateApptDate: AppointmentActionCreator.UpdateApptDate,
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    clearMainPanes: FrameworkActionCreator.clearMainPanes,
    setViewMode: FrameworkActionCreator.acSetViewMode,
    clearCustInfo: CustomerActionCreator.ClearCustInfo,
    clearVehicles: VehiclesActionCreator.ClearVehicles,
    clearNewVehicle: NewVehicleActionCreator.ClearNewVehicle,
    clearApptState: AppointmentActionCreator.ClearApptState,
    clearROState: RepairOrdersActionCreator.ClearROState,
    clearROHistory: ROHistoryActionCreator.ClearROHistory,
    clearMenusState: MenusActionCreator.ClearMenusState,
    clearAddlTrackCustInfo: FrameworkActionCreator.ClearAddlTrackCustInfo,
    waitForLogOff: CustomerActionCreator.WaitForLogOff,
    logCustOff: CustomerActionCreator.LogCustOff,
    selectVehicle: VehiclesActionCreator.SelectVehicle,
    onAppCustUpdate: AppointmentActionCreator.UpdateApptCust,
    customerSearch: CustomerActionCreator.CustomerSearch,
    setNextVehAppt: VehiclesActionCreator.SetVehNextAppt,
    getVehicles: VehiclesActionCreator.GetVehicles,
    setLoadingStateToIdle: CustomerActionCreator.SetLoadingStateToIdle,
    setVinCustReturned: CustomerActionCreator.SetVinCustReturned,
    setAddlTrackData: FrameworkActionCreator.SetAddlTrackData,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Confirmation);